export default "__VITE_ASSET__CeSvyZ$D__"